import React from 'react';
import { FaInfoCircle as IconInfo, FaTimes as IconClose } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

interface Props {
	notification: ToastNotification;
	onRemove: (notification: ToastNotification) => void;
}

const styleMap = {
	info: 'info',
	success: 'primary',
	warning: 'warning',
	danger: 'danger',
};

const Notification: React.FC<Props> = ({ onRemove, notification }) => {
	const { push } = useHistory();

	React.useEffect(() => {
		if (notification.timeout) {
			const visibleTimeout = window.setTimeout(() => {
				onRemove(notification);
			}, notification.timeout);

			return () => {
				if (visibleTimeout) clearTimeout(visibleTimeout);
			};
		}
	}, [notification, onRemove]);

	return (
		<div
			className={`_px-4 _py-3 _my-2 _bg-white _border-t-4 _rounded-b _shadow-md _border-${styleMap[notification.type]}`}
			role="alert"
		>
			<div className="_flex">
				<div className="_w-6 _mr-4">
					<IconInfo className={`_w-6 _h-6 _text-${notification.type}`} />
				</div>
				<div className="_flex-grow">
					<p className="_mb-1 _font-bold">{notification.title}</p>
					<p className="_text-sm">{notification.message}</p>
					{notification.link && (
						<button
							className={`_px-2 _py-1 _text-white _font-semibold _text-sm _mt-2 _bg-${styleMap[notification.type]}`}
							onClick={() => {
								if (notification.link?.url) push(notification.link.url);
								onRemove(notification);
							}}
						>
							{notification.link.name}
						</button>
					)}
				</div>
				<button onClick={() => onRemove(notification)} className="_w-4 _h-4 _flex-end">
					<IconClose className="_w-5 _h-5 _text-gray-700" />
				</button>
			</div>
		</div>
	);
};

export default Notification;
